export default {
  fieldsCompleted(fields) {
    return !this.getEmptyFields(fields).length
  },

  getEmptyFields(fields) {
    return fields.filter(field => field.content.length < 1 || field.content == 0).map(field => field.name)
  },

  fieldsMessage(fields) {
    let message
    let emptyFields = this.getEmptyFields(fields)

    if (emptyFields.length === 1) {
      message = `The ${emptyFields[0]} field is empty<br><br>Make sure to fill it before submitting`
    }

    if (!message) {
      const last = emptyFields.pop()
      const finalString = `${emptyFields.join(', ')} and ${last}`
      message = `The following fields are empty:<br><br>${finalString}<br><br>Make sure to fill all fields before submitting`
    }

    return message
  },
}
